import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

const setDefaultDates = () => fromJS({
  filters: {
    date_from: moment().startOf('year').subtract(3, 'years').toDate(),
    date_to: moment().startOf('day').toDate(),
  },
});

export const analyticsReportReducer = (state = setDefaultDates(), action) => {
  switch (action.type) {
    case 'LOGOUT':
    case 'CLEAR_ANALYTICS_REPORT':
      return new Map();
    case 'ANALYTICS_REPORT_SET_DEFAULT_DATES':
      return setDefaultDates();
    case 'ANALYTICS_REPORT_UPDATE_FILTER':
      return state.setIn(['filters', action.field], action.value);
    case 'ANALYTICS_REPORT_EPI_UNIQUES_LOADED':
      return state.set('priceItems', fromJS(action.data));
    case 'ANALYTICS_REPORT_PRODUCT_TYPES_LOADED':
      return state.set('productTypes', fromJS(action.data));
    case 'ANALYTICS_REPORT_EPTCR_UNIQUES_LOADED':
      return state.set('importExportItems', fromJS(action.data));
    case 'ANALYTICS_REPORT_IMPORT_EXPORT_REPORT_LOADED':
      return state.set('importExportResult', fromJS(action.data));
    case 'ANALYTICS_REPORT_SUPPLY_DEMAND_REPORT_LOADED':
      return state.set('supplyDemandResult', fromJS(action.data));
    case 'ANALYTICS_REPORT_PRICES_REPORT_LOADED':
      return state.set('pricesResult', fromJS(action.data)
        .map((d, idx) => d.set('id', `price${idx}`)));
    case 'ANALYTICS_REPORT_SUPPLY_DEMAND_TOTALS_REPORT_LOADED':
      return state.set('supplyDemandTotalsResult', fromJS(action.data));
    default:
      return state;
  }
};

export const setDefaultDatesAction = (dispatch) =>
  dispatch({ type: 'ANALYTICS_REPORT_SET_DEFAULT_DATES' });

export const updateFilter = (dispatch, field, value) =>
  dispatch({ type: 'ANALYTICS_REPORT_UPDATE_FILTER', field, value });

export const clearData = (dispatch) => dispatch({ type: 'CLEAR_ANALYTICS_REPORT' });

export const getEPIsUniques = (dispatch) => {
  dispatch({ type: 'ANALYTICS_REPORT_EPI_UNIQUES_LOADING' });
  return RestAPI.get('/pricesdb/api/getUniqueExcelEPI')
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_EPI_UNIQUES_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_EPI_UNIQUES_LOADING_FAILED' });
        return true;
      },
    );
};

export const getUniqueEPTCR = (dispatch) => {
  dispatch({ type: 'ANALYTICS_REPORT_EPTCR_UNIQUES_LOADING' });
  return RestAPI.get('/pricesdb/api/getUniqueEPTCR')
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_EPTCR_UNIQUES_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_EPTCR_UNIQUES_LOADING_FAILED' });
        return true;
      },
    );
};

export const loadProductTypes = (dispatch) => {
  dispatch({ type: 'ANALYTICS_REPORT_PRODUCT_TYPES_LOADING' });
  return RestAPI.get('/references/producttype/api')
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_PRODUCT_TYPES_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_PRODUCT_TYPES_LOADING_FAILED' });
        return true;
      },
    );
};

export const pricesReport = (dispatch, filters) => {
  dispatch({ type: 'ANALYTICS_REPORT_PRICES_REPORT_LOADING' });
  return RestAPI.post('/api/report/pricesReport', filters)
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_PRICES_REPORT_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_PRICES_REPORT_LOADING_FAILED' });
        return true;
      },
    );
};

export const importExportReport = (dispatch, filters) => {
  dispatch({ type: 'ANALYTICS_REPORT_IMPORT_EXPORT_REPORT_LOADING' });
  return RestAPI.post('/api/report/importExportReport', filters)
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_IMPORT_EXPORT_REPORT_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_IMPORT_EXPORT_REPORT_LOADING_FAILED' });
        return true;
      },
    );
};

export const supplyDemandReport = (dispatch, filters) => {
  dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_REPORT_LOADING' });
  return RestAPI.post('/api/report/supplyDemandReport', filters)
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_REPORT_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_REPORT_LOADING_FAILED' });
        return true;
      },
    );
};

export const supplyDemandTotalsReport = (dispatch, filters) => {
  dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_TOTALS_REPORT_LOADING' });
  return RestAPI.post('/api/report/supplyDemandTotalsReport', filters)
    .then(
      (data) => {
        dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_TOTALS_REPORT_LOADED', data });
        return true;
      },
    )
    .catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'ANALYTICS_REPORT_SUPPLY_DEMAND_TOTALS_REPORT_LOADING_FAILED' });
        return true;
      },
    );
};

export const generateReport = (dispatch, filters) => {
  dispatch({ type: 'ANALYTICS_REPORT_GENERATION_LOADING' });
  importExportReport(dispatch, filters);
  pricesReport(dispatch, filters);
  supplyDemandReport(dispatch, filters);
  supplyDemandTotalsReport(dispatch, filters);
};
